import React from 'react';
import { useI18n } from '../i18n';
import { X } from 'lucide-react';

/**
 * AnimalToggleModal — Logo'ya tıklandığında açılan modal
 *
 * Kullanıcı mod seçer: Kedi | Köpek | Hepsi
 * Seçim ana app state'ine kaydedilir (localStorage veya Context)
 */
export default function AnimalToggleModal({ isOpen, onClose, onSelect, country = 'IN', currentMode = 'cats' }) {
  const { lang } = useI18n();

  if (!isOpen) return null;

  // Etiketler kendine-yeter (i18n toggle.* anahtarları yok; dil bloklarına
  // dokunmadan tr/id/en + İngilizce yedek). KÖPEK-3.
  const L = (tr, id, en) => (lang === 'tr' ? tr : lang === 'id' ? id : en);
  const title = L('Hayvan Türü Seç', 'Pilih Jenis Hewan', 'Choose Animal');
  const hint = L('Seçtiğin türe göre hayvanlar filtrelenir',
                 'Hewan difilter sesuai pilihanmu',
                 'Animals are filtered by your choice');
  const CAT = { value: 'cats', label: L('Kedi', 'Kucing', 'Cats'), emoji: '🐱' };
  const DOG = { value: 'dogs', label: L('Köpek', 'Anjing', 'Dogs'), emoji: '🐶' };
  const ALL = { value: 'all', label: L('Hepsi', 'Semua', 'All'), emoji: '🐾' };

  // Turkey: 2 option (köpek gizli) | Other countries: 3 options
  const isTurkey = country === 'TR';
  const options = isTurkey ? [CAT, ALL] : [CAT, DOG, ALL];

  const handleSelect = (value) => {
    onSelect(value);
    onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/30 z-40"
        onClick={onClose}
        style={{ backdropFilter: 'blur(2px)' }}
      />

      {/* Modal */}
      <div className="fixed inset-0 flex items-end z-50">
        <div className="w-full bg-white rounded-t-2xl shadow-2xl p-6 max-h-[50vh] overflow-y-auto">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-stone-900">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-stone-100 rounded-lg transition-colors"
              aria-label="Kapat"
            >
              <X size={20} className="text-stone-600" />
            </button>
          </div>

          {/* Options */}
          <div className="space-y-3">
            {options.map((option) => (
              <button
                key={option.value}
                onClick={() => handleSelect(option.value)}
                className={`w-full p-4 rounded-xl border-2 transition-all font-semibold text-center flex items-center justify-center gap-3 ${
                  currentMode === option.value
                    ? 'border-orange-500 bg-orange-50 text-orange-900'
                    : 'border-stone-200 bg-white text-stone-700 hover:border-orange-300 hover:bg-orange-50'
                }`}
              >
                <span className="text-2xl">{option.emoji}</span>
                <span>{option.label}</span>
              </button>
            ))}
          </div>

          {/* Footer hint */}
          <p className="text-xs text-stone-500 mt-6 text-center">
            {hint}
          </p>
        </div>
      </div>
    </>
  );
}
